export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Delivered.9b96c3fa.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};